import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../Apis/apiCall";
import { handleApiResponse } from "../utils/response";
import Breadcrumb from "../components/Breadcrumb";
import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";

const AddClientPermissionPage = () => {
  const [newPermission, setNewPermission] = useState({
    permission_key: "",
    description: "",
    module_name: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getAuthToken = () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      setErrorMessage("Please log in to continue.");
    }
    return token;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setErrorMessage("");
      const token = getAuthToken();
      if (!token) {
        setErrorMessage("Authentication token missing. Please log in.");
        setLoading(false);
        return;
      }

      const response = await apiCall(
        "post",
        "/add-client-permission",
        newPermission,
        navigate
      );

      if (response?.data?.success) {
        handleApiResponse(response.data, "success", "POST");
        navigate("/client-permissions");
      } else {
        setErrorMessage(response?.data?.message || "Failed to add permission.");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "POST");
      setErrorMessage(error.message || "Error adding permission.");
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = () => {
    return newPermission.permission_key.trim() !== "" && newPermission.module_name.trim() !== "";
  };

  return (
    <>
      <Breadcrumb title="Add Permission" />

      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          {errorMessage && (
            <div
              className="alert alert-danger alert-dismissible fade show mb-3"
              role="alert"
            >
              {errorMessage}
              <button
                type="button"
                className="btn-close"
                onClick={() => setErrorMessage("")}
              ></button>
            </div>
          )}

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-20">
              <div className="col-md-6 mb-20">
                <label htmlFor="permissionKey" className="form-label">
                  Permission Key *
                </label>
                <input
                  id="permissionKey"
                  type="text"
                  className="form-control radius-8"
                  value={newPermission.permission_key}
                  onChange={(e) =>
                    setNewPermission({
                      ...newPermission,
                      permission_key: e.target.value,
                    })
                  }
                  placeholder="Enter permission key"
                  required
                />
              </div>

              <div className="col-md-6 mb-20">
                <label htmlFor="description" className="form-label">
                  Description
                </label>
                <input
                  id="description"
                  type="text"
                  className="form-control radius-8"
                  value={newPermission.description}
                  onChange={(e) =>
                    setNewPermission({
                      ...newPermission,
                      description: e.target.value,
                    })
                  }
                  placeholder="Enter description"
                />
              </div>

              <div className="col-md-6 mb-20">
                <label htmlFor="moduleName" className="form-label">
                  Module Name *
                </label>
                <input
                  id="moduleName"
                  type="text"
                  className="form-control radius-8"
                  value={newPermission.module_name}
                  onChange={(e) =>
                    setNewPermission({
                      ...newPermission,
                      module_name: e.target.value,
                    })
                  }
                  placeholder="Enter module name"
                  required
                />
              </div>
            </div>

            <div className="d-flex justify-content-center gap-3">
              <CancelButtonForm />
              <UpdateButtonForm
                disabled={loading || !isFormValid()}
                text={loading ? "Please wait..." : "Add Permission"}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddClientPermissionPage;